import { useEffect, useState } from "react";
import { scrollToId, scrollTop } from "../lib/smooth";

function NavLink({ id, label, testId }) {
    return (
        <button
            type="button"
            data-testid={testId}
            onClick={() => scrollToId(id)}
            className="text-[10px] md:text-xs uppercase tracking-[0.14em] md:tracking-[0.2em] text-garden/70 hover:text-rose transition-colors duration-200"
        >
            {label}
        </button>
    );
}

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-300 ${
                scrolled
                    ? "bg-blush/90 backdrop-blur-xl border-garden/15"
                    : "bg-gradient-to-b from-blush/80 to-transparent border-transparent"
            }`}
        >
            <nav aria-label="Main navigation" className="grid grid-cols-[1fr_auto_1fr] items-center h-14 md:h-16 px-5 md:px-10 max-w-[1600px] mx-auto w-full">
                <div className="flex items-center gap-4 md:gap-8">
                    <NavLink id="about" label="About" testId="nav-about-link" />
                </div>
                <button
                    type="button"
                    data-testid="nav-wordmark"
                    onClick={scrollTop}
                    aria-label="Mashi J — back to top"
                    className="font-display font-extrabold uppercase tracking-tight text-lg md:text-2xl text-garden hover:text-rose transition-colors duration-200"
                >
                    Mashi&nbsp;<span className="text-rose">J</span>
                </button>
                <div className="flex items-center justify-end gap-4 md:gap-8">
                    <NavLink id="follow" label="Follow" testId="nav-follow-link" />
                </div>
            </nav>
        </header>
    );
}
